<template>
  <div class="enviroment-config"></div>
</template>

<script setup lang="ts">
import { useConfigStore } from "@/stores/config";
import { watch } from "vue";

const configStore = useConfigStore();

// Function to set the favicon dynamically based on the environment
function setFavicon(faviconUrl: string) {
  // Set the favicon href dynamically
  const link = document.querySelector("link[rel='icon']") as HTMLLinkElement;
  if (link) {
    link.setAttribute("href", faviconUrl);
  }
}

// Watch for changes in the `configStore.strax.url` and update the favicon accordingly
// Run immediately as well
watch(
  () => configStore.strax.url,
  (newUrl) => {
    setFavicon(`${newUrl}/sada_logo.svg`);
  },
  { immediate: true } // Ensures the watcher runs immediately on mount
);
</script>
